import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../types/state/AppState';
import { isRequestNone } from '../utils';
import { brokerDealerListActions } from '../actions/broker-dealer-list.actions';

export const useBrokerDealers = (requestEnabled: boolean = true) => {
    const dispatch = useDispatch();

    const items = useSelector((state: AppState) => state.entities.brokerDealerList.items);
    const requestState = useSelector((state: AppState) => state.entities.brokerDealerList.requestState);

    useEffect(() => {
        if (isRequestNone(requestState) && requestEnabled) {
            dispatch(brokerDealerListActions.request());
        }
    }, [dispatch, requestState, requestEnabled]);

    return { requestState, items }
};
